import React, { useEffect } from "react";

function NoteToast({ message, variant = "success", onClose, duration = 3200 }) {
  useEffect(() => {
    const timer = window.setTimeout(() => {
      onClose?.();
    }, duration);

    return () => window.clearTimeout(timer);
  }, [duration, onClose, message]);

  if (!message) {
    return null;
  }

  const isError = variant === "error";

  return (
    <div
      className={`my-notes-toast ${isError ? "is-error" : "is-success"}`}
      role="status"
      aria-live="polite"
    >
      <span className="my-notes-toast-icon" aria-hidden="true">
        {isError ? "!" : "✓"}
      </span>
      <span>{message}</span>
    </div>
  );
}

export default NoteToast;
